export default __webpack_public_path__ + "static/icon-form-success-d731fab4603c7ad2bb2d5ff36efa9a61.png";